<template>
  <div class="bubble" :class="align" v-if="bubble">
    <div class="color" v-if="bubble.color" :style="{backgroundColor: bubble.color}"></div>
    <div class="color" v-else :style="{backgroundColor: '#dadada'}"></div>

    <button class="name" v-if="bubble.name" @click="openEdition = true">{{ bubble.name }}</button>

    <div class="users">
      <span class="tag">
        <font-awesome-icon icon="users"></font-awesome-icon>&nbsp;&nbsp;{{ bubble.usercount }}
      </span>
      <span class="tag" v-for="(tag, index) in bubble.tags" :key="index">{{ tag.value }}</span>
    </div>

    <k-dropdown>
      <template slot="handler">
        <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
      </template>
      <k-dropdown-option @click.native="refresh">Refresh</k-dropdown-option>
      <k-dropdown-option @click.native="openEdition = true">Edit</k-dropdown-option>
      <k-dropdown-option @click.native="exportCSV">Export</k-dropdown-option>
      <k-dropdown-option @click.native="openTriggerEvent = true">Send event</k-dropdown-option>
      <k-dropdown-option @click.native="deleteBubbleConfirmation = true">Delete</k-dropdown-option>
    </k-dropdown>

    <div class="loading-actions"  v-if="loadingExport">
      <font-awesome-icon class="loader-cog" icon="cog" spin></font-awesome-icon>
    </div>

    <bubbles-ui-sidebar-create
      v-if="openEdition"
      :bubble-id="id"
      :wavesLinked="bubble.waves"
      :bannersLinked="bubble.banners"
      :npsLinked="bubble.npss"
      @close="() => { close() }"/>

    <trigger-event v-if="openTriggerEvent" :id="id" :open="openTriggerEvent" @close="closePopups" :idBubble="id"></trigger-event>
    <message-form v-if="openMessageForm" :id="id" :open="openMessageForm" @close="closePopups" :idBubble="id"></message-form>

    <modal-confirmation
      v-if="deleteBubbleConfirmation"
      :open="deleteBubbleConfirmation"
      type="danger"
      messageTitle="Warnings !"
      :message="messageDeletion"
      :wavesLinked="bubble.waves"
      :bannersLinked="bubble.banners"
      :npsLinked="bubble.npss"
      messageAction="Yes, I'm sure !"
      @execute="remove"
      @close='deleteBubbleConfirmation = false' />
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import dropdown from '@/components/dropdown.vue'
import triggerEvent from '@/components/events/trigger-event.vue'
import messageForm from '@/components/messages/message-form.vue'
import HTTP from '@rocketfid/api'
import ModalConfirmation from '@/components/others/utils/ModalConfirmation.vue'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    align: {
      type: String,
      required: false
    }
  },
  components: {
    dropdown, triggerEvent, messageForm, ModalConfirmation
  },
  data () {
    return {
      openEdition: false,
      openTriggerEvent: false,
      openMessageForm: false,
      loadingExport: false,
      deleteBubbleConfirmation: false
    }
  },

  computed: {
    ...mapGetters('bubbles', {
      getById: 'getById'
    }),

    bubble () {
      if (!this.getById(this.id)) {
        this.$destroy()
      } else {
        return this.getById(this.id)
      }
    },

    messageDeletion() {
      console.log('The bubble : ', this.bubble);
      let message = 'Deletion leads to deactivation of '
      if (this.bubble.bannerscount && this.bubble.wavescount && this.bubble.npsscount) {
        message += 'waves, banners, and surveys'
      } else if (this.bubble.bannerscount && this.bubble.wavescount) {
        message += 'waves and banners'
      } else if (this.bubble.bannerscount && this.bubble.npsscount) {
        message += 'banners and surveys'
      } else if (this.bubble.wavescount && this.bubble.npsscount) {
        message += 'waves and surveys'
      } else if (this.bubble.bannerscount) {
        message += 'banners'
      } else if (this.bubble.wavescount) {
        message += 'waves'
      } else if (this.bubble.npsscount) {
        message += 'surveys'
      } else {
        message = 'Are you sure you want to delete this bubble?'
      }
  return message
}

  },

  methods: {
    ...mapActions('bubbles', ['refreshBubble', 'removeBubble']),

    refresh () {
      this.refreshBubble({bubble: this.bubble}).then(() => {
        this.$notify({ title: 'Success', message: this.$root.$t('notifications.bubble.refreshed'), type: 'success' })
      }).catch((response) => {
        this.$notify.error({
          title: this.$root.$t('api.' + response.code + '.title'),
          message: this.$root.$t('api.' + response.code + '.message')
        })
      })
    },
    remove () {
      this.removeBubble({bubble: this.bubble}).then(() => {
        this.$notify({ title: 'Success', message: this.$root.$t('notifications.bubble.deleted'), type: 'success' })
      }).catch((response) => {
        this.$notify.error({
          title: this.$root.$t('api.' + response.code + '.title'),
          message: this.$root.$t('api.' + response.code + '.message')
        })
      })
    },

    exportCSV () {
      this.loadingExport = true

      HTTP.axios.get(process.env.API + '/bubble/export/bubbles/' + this.id + '/').then((json) => {
        this.loadingExport = false
        this._downloadCSV(json.data, this.bubble.name)
      }).catch(() => {
        this.loadingExport = false
      })
    },

    closePopups () {
      this.openTriggerEvent = false
      this.openMessageForm = false
    },

    close () {
      this.openEdition = false
      this.$emit('reload', true)
    }
  }
}

</script>

<style lang="scss" scoped>
  .bubble {
    background: #fff;
    padding: 12px 4px;
    margin: 12px;
    box-shadow: 0 0.1rem 0.5rem rgba(0, 0, 0, 0.08);
    direction: ltr;
    position: relative;
    align-items: center;
    font-size: 14px;
    display: grid;
    border-bottom: 1px solid #dedede;
    grid-template-columns: 20px 1fr 24px;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 4px;
    grid-template-areas:
      "color name actions"
      "color users actions"
      ;

    // &.horizontal {
    //   // display: inline-block;
    // }

    .name {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
      grid-area: name;
      max-width: fit-content;

    }
    .color {
      grid-area: color;
      text-align: center;
      height: 100%;
      width: 4px;
      margin-left:6px;
      border-radius: 2px;
    }
    .users {
      grid-area: users;
      > span {
        background: #eaeaea;
        color: #565656;
      }
    }
    .actions {
      grid-area: actions;
    }

    .loading-actions {
      width: 16px;
      height: 16px;
      position: absolute;
      bottom: 8px;
      right: 8px;
      color: #aeaeae;
      font-size: 16px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/customers/bubble.vue